import { FormEvent, useState } from 'react';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import { AuthSplitLayout } from '../../components/AuthSplitLayout';
import { Button } from '../../components/Button';
import { Input } from '../../components/Input';
import { esqueciSenha } from '../../api/auth';

export function EsqueciSenha() {
  const [email, setEmail] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [enviado, setEnviado] = useState(false);

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    setEnviando(true);

    try {
      await esqueciSenha(email);
      setEnviado(true);
    } catch (error: any) {
      Swal.fire({
        icon: 'error',
        title: 'Algo deu errado',
        text: error.response?.data?.erro || 'Tente novamente em instantes.',
        confirmButtonColor: '#1845ba',
      });
    } finally {
      setEnviando(false);
    }
  }

  if (enviado) {
    return (
      <AuthSplitLayout titulo="Verifique seu e-mail">
        <p style={{ fontSize: '14px' }}>
          Se houver uma conta com esse e-mail, enviamos um link para redefinir a senha.
        </p>
        <div className="mt-3 text-center" style={{ fontSize: '14px' }}>
          <Link to="/login">Voltar para o login</Link>
        </div>
      </AuthSplitLayout>
    );
  }

  return (
    <AuthSplitLayout titulo="Esqueci minha senha" subtitulo="Enviaremos um link de redefinição para o seu e-mail.">
      <form onSubmit={handleSubmit}>
        <Input label="E-mail" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
        <Button type="submit" disabled={enviando}>
          {enviando ? 'Enviando...' : 'Enviar link de redefinição'}
        </Button>
      </form>
      <div className="mt-3 text-center" style={{ fontSize: '14px' }}>
        <Link to="/login">Voltar para o login</Link>
      </div>
    </AuthSplitLayout>
  );
}
